export default __webpack_public_path__ + "static/media/dark_plus_icon.84c533fd.svg";